import { Reducer } from 'redux';
import { DashboardActionTypes } from './actions';
import { IPbiReport } from '../../PowerBI/business-objects/types';
import { Dashboard } from 'powerbi-client';

interface IDashboardState {
  reports: IPbiReport[];
}
// Type-safe initialState!
const initialState = {
  reports: [],
};

type IDashboardStoreState = Readonly<IDashboardState>;

const reducer: Reducer<IDashboardState> = (state = initialState, action) => {
  switch (action.type) {
    case DashboardActionTypes.GET_MY_REPORTS: {
      console.log('search result:', action.value);
      let _state = { ...state };
      _state = { ..._state, reports: action.value };
      return _state;
    }
    default: {
      return state;
    }
  }
};

export default reducer;
